import { useState } from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { getGoogleCalendarUrl } from '../utils/googleCalendar';
import type { EventById } from '../features/events/api/useGetEventById';

type Props = {
  event: EventById;
};

export function useEventContent(props: Props) {
  const { isAdmin } = usePermissions();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);

  function handleAddToGoogleCalendar() {
    window.open(getGoogleCalendarUrl(props.event, window.location.href), '_blank', 'noopener,noreferrer');
  }

  return {
    isAdmin,
    isDeleteModalOpen,
    isEditModalOpen,
    handleOpenEditModal: () => setIsEditModalOpen(true),
    handleCloseEditModal: () => setIsEditModalOpen(false),
    handleOpenDeleteModal: () => setIsDeleteModalOpen(true),
    handleCloseDeleteModal: () => setIsDeleteModalOpen(false),
    handleAddToGoogleCalendar,
  };
}
